import { render, staticRenderFns } from "./IndexBK.vue?vue&type=template&id=766d80ca&scoped=true&"
import script from "./IndexBK.vue?vue&type=script&lang=js&"
export * from "./IndexBK.vue?vue&type=script&lang=js&"
import style0 from "./IndexBK.vue?vue&type=style&index=0&id=766d80ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d80ca",
  null
  
)

export default component.exports